import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { CreateBidFormOutput } from "../../../../../components/bids/create_bid/CreateBidForm";
import { BidWorkflowQuery } from "../../../../generated/app-service-gql/graphql";
import { useBidWorkflow } from "./useBidWorkflow";

/**
 * Hook which fetches the bid workflow and determines the default stage ID. It will either be
 * the stage ID provided in the defaultValues, or the first stage in the workflow if none is provided.
 * @param defaultValues
 * @param options
 * @returns
 */
export function useDefaultBidWorkflowStage(
  defaultValues?: Partial<CreateBidFormOutput>,
  options?: UseQueryOptions<BidWorkflowQuery, unknown, BidWorkflowQuery, QueryKey>,
) {
  const { data: workflow, isLoading } = useBidWorkflow(
    {},
    {
      ...options,
      enabled: !defaultValues?.stageId,
    },
  );

  const defaultStageId = defaultValues?.stageId ?? workflow?.transitions[0].stage.id;
  return {
    defaultStageId,
    isLoading: !defaultValues?.stageId && isLoading,
  };
}
